import type { FC } from "react";
import { twMerge } from "tailwind-merge";

export type ChatSeparatorProps = {
  className?: string;
  children: React.ReactNode;
};

export const ChatSeparator: FC<ChatSeparatorProps> = ({ className, children }) => (
  <div className={twMerge("flex w-full items-center justify-center gap-2 bg-white", className)}>
    <hr className="grow text-black-tint-95" />
    <div className="text-xs font-normal text-black-tint-40">{children}</div>
    <hr className="grow text-black-tint-95" />
  </div>
);
